export const PURCHASE_DOCUMENT_STATUSES = ['', '✓', '✕', 'PE', 'DR', 'Refund', '?'];
